// @flow
import { createReducer } from "state/utils";
import * as workspacesTypes from "state/ducks/workspaces/types";
import * as uiTypes from "./types";

/**
 * The form state will go through a cycle:
 *     initial -> requesting -> [completed|failed]
 *     initial:             initial state of the form, you can click on the submit button
 *     requesting:          submit button has been clicked and request is in progress
 *     [completed|failed]:  the request has either completed or failed
 *
 * The errorFields will contain the list of fields that have issues
 * The message field will contain the error message
 * Message type is used to display a warning or error message
 */

const INITIAL_STATE = {
  errorFields: {},
  formState: "pending",
  message: "",
  messageType: "warning"
};

export default createReducer(INITIAL_STATE)({
  [workspacesTypes.UPDATE_REQUESTED]: (state, action) => {
    return {
      errorFields: [],
      formState: "requesting",
      message: "",
      messageType: "warning"
    };
  },
  [workspacesTypes.UPDATE_COMPLETED]: (state, action) => {
    return {
      errorFields: [],
      formState: "completed",
      message: "Your workspace has been updated",
      messageType: "success"
    };
  },
  [workspacesTypes.UPDATE_FAILED]: (state, action) => {
    const errors = action.error.response.data;
    const errorFields = {};
    if (errors["accepted_domains"]) {
      errorFields["accepted_domains"] =
        "Please check that the email domains are correct (ex: acme.com, acme.com.au...)";
    }
    if (errors["slug"]) {
      errorFields["slug"] = "Slug is invalid";
    }
    if (errors["otp_required"]) {
      errorFields["otp_required"] = "Sorry but we could not save your preference";
    }
    if (errors["restricted_domains"]) {
      errorFields["restricted_domains"] =
        "Please check that the email domains are correct (ex: acme.com, acme.com.au...)";
    }
    if (errors["restricted_ips"]) {
      errorFields["restricted_ips"] = "Please check that the IP addresses are in the proper IPv4 or IPv6 format";
    }
    return {
      errorFields,
      formState: "failed",
      message: "Sorry but we could not update your workspace",
      messageType: "warning"
    };
  },
  [uiTypes.CLEAR_PAGE]: () => INITIAL_STATE
});
